export const TITLE_CLASS = 'text-base font-semibold text-[#1d1d1f]';

export const CAPTION_CLASS = 'text-[11px] font-semibold uppercase tracking-wider text-gray-500';

export const SECTION_LABEL_CLASS = 'text-sm font-semibold uppercase tracking-wider';

export const BODY_CLASS = 'text-sm text-[#1d1d1f]';

export const BODY_SOFT_CLASS = 'text-sm text-gray-500';

export const DETAIL_CLASS = 'text-xs text-gray-500';

export const MUTED_CLASS = 'text-gray-400';
